export const Gray = '#575757';

export const LigthGray = '#d3d3d3';

export const DarkGray = '#a9a9a9';

export const DarkBlue = '#002d62';

export const DarkBlueHover = '#3079d1';

export const Red = '#a6312d';

export const DarkRedHover = '#6b1e1e'

export const LigthGreen = '#2dca98'

export const DarkGreen = '#25a37b'
